import { Component, Input, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { PieItem } from 'src/app/shared/helper/pie-utils.service';

@Component({
  selector: 'app-pie-graph',
  templateUrl: './pie-graph.component.html',
  styleUrls: ['./pie-graph.component.scss']
})
export class PieGraphComponent implements AfterViewInit {

  @Input() title: string = "";
  @Input() data: PieItem[] = [];

  @ViewChild("canvas", { static: true }) canvas!: ElementRef<HTMLCanvasElement>;

  colorScheme = [
    "#4E79A7","#F28E2B","#E15759","#76B7B2",
    "#59A14F","#EDC949","#AF7AA1","#FF9DA7",
    "#9C755F","#BAB0AB","#2A9D8F","#E76F51"
  ];

  ngAfterViewInit() {
    this.drawPie();
  }

  redraw() {
    this.drawPie();
  }

  drawPie() {
    if (!this.canvas) return;

    const canvas = this.canvas.nativeElement;
    const ctx = canvas.getContext("2d")!;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const total = this.data.reduce((t, x) => t + x.value, 0);
    if (total <= 0) return;

    let startAngle = -Math.PI / 2;
    const cx = canvas.width / 2;
    const cy = canvas.height / 2;
    const r = Math.min(cx, cy) - 10;

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "bold 13px Arial";

    this.data.forEach((item, index) => {
      const slice = (item.value / total) * Math.PI * 2;
      const end = startAngle + slice;

      // Draw slice
      ctx.fillStyle = this.colorScheme[index % this.colorScheme.length];
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, r, startAngle, end);
      ctx.closePath();
      ctx.fill();

      // Draw percentage inside the slice
      const mid = startAngle + slice / 2;
      const lx = cx + Math.cos(mid) * (r * 0.55);
      const ly = cy + Math.sin(mid) * (r * 0.55);

      // ctx.fillStyle = "#fff";
      // ctx.fillText(((item.value / total) * 100).toFixed(0) + "%", lx, ly);

      startAngle = end;
    });
  }
}
